import { render, staticRenderFns } from "./ExpiredMembership.vue?vue&type=template&id=6abf593e"
import script from "./ExpiredMembership.vue?vue&type=script&lang=ts"
export * from "./ExpiredMembership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports